import React, { useContext } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import WP from "WP";

import { setOverlayValue } from "store";
import ImageGalleryContext from "context/image-gallery-context";

import Container from "partials/Container";
import GridElement from "partials/GridElement";
import Html from "partials/Html";

import CrossIcon from "icons/CrossIcon";

import Media from "css/Media";

const CancelOrderTerms = (props) => {
  const imageGalleryContext = useContext(ImageGalleryContext);

  const clickHandler = () => {
    document.getElementsByTagName("html")[0].style.overflowY = "visible";
    props.setOverlayValue({ visible: false });
    imageGalleryContext.setOpen(false);
  };

  return (
    <Wrapper>
      <Container grid>
        <GridElement
          colStart={{ default: 7, s: 23 }}
          colEnd={{ default: 8, s: 24 }}
          rowStart={1}
          justify='end'
        >
          <ExitButton onClick={clickHandler}>
            <CrossIcon />
          </ExitButton>
        </GridElement>
        <ContentGridElement
          colStart={{ default: 1, s: 5 }}
          colEnd={{ default: 8, s: 20 }}
          rowStart={2}
        >
          <h3>
            {WP && WP.lang === "en" && WP.options.booking_terms_title_en
              ? WP.options.booking_terms_title_en
              : WP.options.booking_terms_title}
          </h3>
          <StyledHtml content>
            {WP && WP.lang === "en" && WP.options.booking_terms_en
              ? WP.options.booking_terms_en
              : WP.options.booking_terms}
          </StyledHtml>
          <CloseButton onClick={clickHandler}>Lukk</CloseButton>
        </ContentGridElement>
      </Container>
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  overlayValue: state.overlayValue,
});

const actions = {
  setOverlayValue,
};

export default connect(mapStateToProps, actions)(CancelOrderTerms);

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.text};
  overflow-y: scroll;

  .container {
    margin: 45px 0;

    ${Media.greaterThan("s")`
      margin-top: 64px;
    `}
  }
`;

const ExitButton = styled.button`
  cursor: pointer;
  padding-bottom: 45px;
`;

const ContentGridElement = styled(GridElement)`
  background-color: ${(props) => props.theme.colors.negative};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 40px;

  h3 {
    margin-bottom: 45px;
    line-height: 27px;

    ${Media.greaterThan("s")`
      margin-bottom: 65px;
    `}
  }

  ${Media.greaterThan("s")`
    padding: 100px;
  `}
`;

const StyledHtml = styled(Html)`
  margin-bottom: 130px;

  ${Media.greaterThan("s")`
    margin-bottom: 80px;
  `}
`;

const CloseButton = styled.div`
  border: 2px solid ${(props) => props.theme.colors.text};
  border-radius: 50px;
  padding: 20px 60px;
  display: inline-block;
  text-align: center;
  align-self: center;
  cursor: pointer;
`;
